import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { getLatestPresentationBuildRun, getPresentation } from '@/api/presentations/presentations'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { PageHeader } from '@/components/PageHeader'
import { PresentationWorkspace } from '@/components/presentation/PresentationWorkspace'

const searchSchema = z.object({ autobuild: z.boolean().optional() })

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/')({
  validateSearch: searchSchema,
  loader: async ({ params }) => {
    const projectId = Number(params.projectId)
    const presentationId = Number(params.presentationId)
    const [presentation, latestRun] = await Promise.all([
      getPresentation(projectId, presentationId),
      getLatestPresentationBuildRun(projectId, presentationId)
    ])
    return { presentation, latestRun }
  },
  head: () => ({ meta: [{ title: 'Presentation Agent - Snowvault' }] }),
  component: PresentationAgentWorkspace
})

function PresentationAgentWorkspace() {
  const { presentation, latestRun } = Route.useLoaderData()
  const { orgSlug } = Route.useParams()
  const { autobuild } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { projectTitle, projectTo } = useProjectBreadcrumb()
  return (
    <>
      <PageHeader
        breadcrumbs={[
          { label: projectTitle, to: projectTo },
          { label: 'Presentation Agent' },
          { label: presentation.title }
        ]}
      />
      <PresentationWorkspace
        key={presentation.presentationId}
        orgSlug={orgSlug}
        initialPresentation={presentation}
        initialRun={latestRun}
        autobuild={autobuild ?? false}
        onAutobuildConsumed={() => navigate({ search: {}, replace: true })}
      />
    </>
  )
}
